module.exports = __webpack_public_path__ + "static/media/dots.fc0c04ba.svg";